import type { FaireProductEntity } from "../../entity_types/product";

export const p_9s4n377a89: FaireProductEntity = {
  token: "p_9s4n377a89",
  type: "product",
  name: "Hot Toddy Single Serve Craft Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/c1da5f79e5deeba50678671195cc97a26605543ab8f1c82cea9c1cc0fcb30ea7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ec412b2afcf3a6f18d208aaa13d353bac91ed6461c56b23c1a89011976db4ea.jpeg",
    "https://cdn.faire.com/fastly/9a69637482b81931461384abf5cc4670c1011d7379ec309c5801f5b0ee142dc6.jpeg",
    "https://cdn.faire.com/fastly/9f6b241d14aab2fa948058387a9bb6a4ccc5bb6db19421e56cb41ea530d84fe3.jpeg",
  ],
  priceDollars: 1.4,
  description:
    "Hot Toddy Single Serve Craft Cocktail (or Mocktail) $1.40 each- Sold In quantities of 24 (Eligible For FREE Display Box Please Order Separately). \n\nNoble Mick's single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick's is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick's we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!",
  tags: [],
  msrpDollars: 2.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:08:59.642Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
